import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/loading";
import { UserRole } from "../api/interface/user.interface";

interface RoleGuardProps {
  roles: UserRole[];
}

export const RoleGuard = ({ roles }: RoleGuardProps) => {

  const { user, isLoading } = useAuth();

  if (isLoading) return <Loading />;

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  const userRoles = user.roles?.map(r => r.name) || [];

  const hasAccess = roles.some(role =>
    userRoles.includes(role)
  );

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};